export { default } from './svg/check-fill.svg';
